// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1G6op","detailsBorder":"styles_detailsBorder__2sB4n"};